import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { adminBotService } from 'src/app/services/bot.admin.service';
import { MarketPriceFacade } from 'src/app/store/marketprice';
import { spotSocket, adminBotSocket } from 'src/app/app.module';
import { TradePairFacade } from 'src/app/store/bottradepair';
import { truncateDecimals, toFixedDown } from 'src/app/lib/roundOf';

@Component({
  selector: 'app-adminBotstop',
  templateUrl: './adminBotstop.component.html',
  styleUrls: ['./adminBotstop.component.css']
})
export class adminBotstopComponent {
  @Input() botDetails: any;
  @Output() gotoStep = new EventEmitter<any>();

  loader = false;
  posData: any = [];
  pairData: any = {}
  isSubmitting = false;
  tickerData: any = {}
  estimatePnl: number = 0
  receiveAmount: number = 0
  currentTradePair: any = {}
  pendingQuantity: number = 0
  pendingOrderValue: number = 0
  selectedOption: string = 'keep';
  showLoaderPage = false
  loaderPercentage = 0
  truncateDecimals = truncateDecimals
  parseFloat: any = parseFloat
  constructor(
    private botFacade: TradePairFacade,
    private marketPriceFacade: MarketPriceFacade,
    private AdminBotSocket: adminBotSocket,
    private service: adminBotService,
    private toastr: ToastrService,
  ) { }
  closeBot() {
    this.loader = true;
    this.isSubmitting = true;
    this.toastr.success("Please wait for a while")
    this.showBotCreateLoader(true)
    // try {
    let reqData = {
      exchange: this.pairData.botstatus,
      botId: this.botDetails?._id ? this.botDetails?._id : "",
      positionId: "",
      // stopMarket: true
      stopMarket: this.selectedOption !== "convert"
    };
    if (!this.botDetails?.isBot) {
      reqData.positionId = this.botDetails?._id ? this.botDetails?._id : ""
      reqData.botId = ""
    }
    this.service.closeBot(reqData)
      .subscribe({
        next: (v: any) => {
          this.loader = false
          if (v.status) {
            this.toastr.success(v.message)
          } else {
            this.toastr.success(v.message)
          }
          this.isSubmitting = false;
          this.gotoStep.emit("one")
        },
        error: (err: any) => {
          this.showBotCreateLoader(false)
          this.loader = false;
          this.isSubmitting = false;

          if (err.error.message) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }

  selectOption(option: string) {
    this.selectedOption = option;
  }
  showBotCreateLoader(state: boolean) {
    this.showLoaderPage = state
    this.botTimer(state)
  }

  botTimer(state: boolean) {
    if (state) {
      const interval = setInterval(() => {
        if (this.loaderPercentage < 90) {
          this.loaderPercentage += 10;
        } else {
          clearInterval(interval); // stop at 90%
        }
      }, 1000);
    } else {
      // Finish to 100%
      const finishInterval = setInterval(() => {
        if (this.loaderPercentage < 100) {
          this.loaderPercentage += 10;
        } else {
          clearInterval(finishInterval);
        }
      }, 200);
    }
  }

  marketPriceWs(result: any) {
    if (this.posData?.length > 0) {
      let estimatePnl = 0, openInvestment = 0, i = 0;
      for (let item of this.posData) {
        if (item?.sellOrderId?.status == 'pending' && item.symbol === result.symbol) {
          let markPrice = parseFloat(result?.data?.bestBid ?? result?.data?.markPrice)
          let entryPrice = (item.buyOrderId.execPrice * item.buyOrderId.fillQuantity) + item.buyOrderId.fee
          let exitPrice = item.sellOrderId.quantity * markPrice
          let exitfee = exitPrice * (0.1 / 100)
          exitPrice = exitPrice - exitfee
          let orderEstProfit = (exitPrice - entryPrice)
          item.profit = orderEstProfit
          openInvestment += parseFloat(item?.buyOrderId?.fillOrderValue ?? 0)
          console.log("fe", 0.1 / 100, item.buyOrderId.fee)
          console.log(i, markPrice, "marketPriceWs", entryPrice, "entryPrice", exitPrice, "exitPrice", "orderEstProfit", orderEstProfit, item?.buyOrderId?.fee)
          console.log("mmmmmmmmmmbuyOrderId", item.buyOrderId.avgPrice, item.buyOrderId.fillQuantity)
          console.log("sellOrderId", item.sellOrderId.avgPrice, item.sellOrderId.quantity)
          i++
        }
        if (this.botDetails?.isBot)
          estimatePnl += item.profit ?? 0
        else if (item?.sellOrderId?.status == 'pending') estimatePnl += item.profit ?? 0
      }
      if (this.botDetails?.isBot) this.receiveAmount = truncateDecimals(estimatePnl + this.botDetails.totalInvestment, 4)
      else if (openInvestment) this.receiveAmount = truncateDecimals(openInvestment + estimatePnl, 4)
      this.posData = [...this.posData];
      this.estimatePnl = truncateDecimals(estimatePnl, 4)
    }
  }

  getPosition() {
    this.loader = true;
    // try {
    let reqData = {
      exchange: this.pairData.botstatus,
      botId: this.botDetails?._id ? this.botDetails?._id : "",
      positionId: '',
      filter: {
        status: "open",
        limit: 100
      }

    };
    if (!this.botDetails?.isBot) {
      reqData.positionId = this.botDetails?._id ? this.botDetails?._id : ""
      reqData.botId = ""
    }
    this.service.getPositionHistory(reqData)
      .subscribe({
        next: (v: any) => {
          this.loader = false
          if (v.success) {
            if (v.result?.length > 0) {
              let profit = 0
              let estimatePnl = 0, i = 0;
              let pendingOrderValue = 0, pendingQuantity = 0, openInvestment = 0
              for (let item of v.result) {
                if (item?.sellOrderId?.status == 'pending') {
                  let markPrice = parseFloat(this.tickerData?.bestBid ?? this.tickerData?.markPrice)
                  let entryPrice = (item.buyOrderId.execPrice * item.buyOrderId.fillQuantity) + item.buyOrderId.fee
                  let exitPrice = item.sellOrderId.quantity * markPrice
                  let exitfee = exitPrice * (0.1 / 100)
                  exitPrice = exitPrice - exitfee
                  let orderEstProfit = (exitPrice - entryPrice)
                  item.profit = orderEstProfit
                  openInvestment += parseFloat(item?.buyOrderId?.fillOrderValue ?? 0)
                  pendingQuantity += parseFloat(item.sellOrderId.quantity)
                  console.log(i, markPrice, "marketPriceWs", entryPrice, "entryPrice", exitPrice, "exitPrice", "orderEstProfit", orderEstProfit, item?.buyOrderId?.fee)
                  console.log("buyOrderId", item.buyOrderId.avgPrice, item.buyOrderId.fillQuantity, "item.buyOrderId.fee", item.buyOrderId.fee)
                  console.log("sellOrderId", item.sellOrderId.avgPrice, item.sellOrderId.quantity)
                  i++
                }
                if (item?.buyOrderId?.status == 'pending') {
                  pendingOrderValue +=
                    toFixedDown(
                      toFixedDown(item.buyOrderId.price, item.buyOrderId.secondFloatDigit) *
                      toFixedDown(item.buyOrderId.quantity, item.buyOrderId.firstFloatDigit),
                      item.buyOrderId.firstFloatDigit + item.buyOrderId.secondFloatDigit
                    )
                }
                if (this.botDetails?.isBot)
                  estimatePnl += item.profit ?? 0
                else if (item?.sellOrderId?.status == 'pending') estimatePnl += item.profit ?? 0
              }
              this.pendingOrderValue = truncateDecimals(pendingOrderValue, 4)
              this.pendingQuantity = truncateDecimals(pendingQuantity, 8)
              
              if (this.botDetails?.isBot) this.receiveAmount = truncateDecimals(estimatePnl + this.botDetails.totalInvestment, 4)
              else if (openInvestment) this.receiveAmount = truncateDecimals(openInvestment + estimatePnl, 4)
              this.estimatePnl = truncateDecimals(estimatePnl, 4)
            }
            this.posData = v.result
          }
        },
        error: (err: any) => {
          this.loader = false;
        }
      })
  }

  ngOnInit() {
    this.botFacade.tradePair$.subscribe(tp => {
      this.currentTradePair = tp;
    });
    this.marketPriceFacade.marketPrice$.subscribe({
      next: (pair: any) => {
        this.tickerData = pair
      },

      error: (err: any) => { }
    })
    this.botFacade.tradePair$.subscribe({
      next: (pair: any) => {
        this.pairData = pair
      },
      error: (err: any) => { }
    })
    this.getPosition();
    this.AdminBotSocket.on('marketPrice', this.marketPriceWs.bind(this))
  }

  prevPage() {
    this.gotoStep.emit("three")
  }

}
